import { combineReducers } from 'redux';

import creationModal from './creationModal';
import filters from './filters';
import ids from './ids';
import isLoading from './isLoading';
import page from './page';

export default combineReducers({
  ids,
  isLoading,
  page,
  filters,
  creationModal,
});
